/**
 * 动作枚举
 */
export enum ActionEnum {
  Clicked = "CLICK",
  Viewed = "VIEW",
}

/**
 * 资源类型枚举
 */
export enum ResourceTypeEnum {
  RecommendApp = "RECOMMEND_APP",
  SupportDoc = "SUPPORT_DOC",
  PARTNERAPP = "PARTNER_APP",
}

/**
 * MonorailProduceMetadata
 */
export interface Metadata {
  /**
   * 事件创建时间（毫秒级）
   */
  event_created_at_ms: number;
  [property: string]: any;
}

/**
 * MonorailProducePayload
 */
export interface Payload {
  /**
   * 动作
   */
  action: ActionEnum;
  /**
   * 识别 ID，传入 UUID。UUID 当用户访问时生成，此后上报都用同一个 UUID
   */
  identity_id: string;
  /**
   * 是否为 PP 员工，从 base_config 拿取
   */
  parcelpanel_employee: boolean;
  /**
   * 资源 ID。如果是进入 App 推荐页面要上报 VIEW 事件传入 0
   */
  resource_id: number;
  /**
   * 资源类型
   */
  resource_type: ResourceTypeEnum;
  /**
   * 店铺 ID，从 base_config 拿取
   */
  shop_id: number;
  [property: string]: any;
}

/**
 * MonorailProduce 请求接口
 */
export interface MonorailProduceRequest {
  metadata: Metadata;
  payload: Payload;
  schema_id: string;
  [property: string]: any;
}

/**
 * 埋点跟踪参数
 */
export interface TrackingParams {
  /**
   * 动作类型
   */
  action: ActionEnum;
  /**
   * 资源类型
   */
  resource_type: ResourceTypeEnum;
  /**
   * 资源ID，如果是查看所有应用推荐页面则传0
   */
  resource_id: number;
  /**
   * 可选的schema_id，如果不传则使用默认值
   */
  schema_id?: string;
}
